// extracted by mini-css-extract-plugin
export default {"dots":"PaginationDots_dots__VR8IX","dot":"PaginationDots_dot__5zLn6","active":"PaginationDots_active__w6Bq0"};